import React, { PureComponent } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import Link from "next/link";

import Head from "../../components/head-data/head-data";
import PageHeading from "../../components/page-heading/page-heading";
import BlogArticles from "../../components/blog-articles/blog-articles";

import getParameterByName from "../../utils/get-url-param-by-name";
import { perPageBlogPosts } from "../../config";

import "./blog.scss";

const BLOG_ARTICLE_CONNECTION_QUERY = gql`
  query BLOG_ARTICLE_CONNECTION_QUERY {
    blogArticlesConnection {
      aggregate {
        count
      }
    }
  }
`;

class Index extends PureComponent {
  render() {
    const { query } = this.props;
    let pageNumber = Number(getParameterByName("pageidxref"));
    let pageName = "FounderCloud Blog";
    if (!pageNumber && query.slug) {
      pageNumber = Number(query.slug.replace("page-", ""));
    }
    if (!pageNumber) pageNumber = 1;
    const variables = {
      first: perPageBlogPosts,
    };
    if (pageNumber > 1) {
      variables.skip = (pageNumber - 1) * perPageBlogPosts;
      pageName = `FounderCloud Blog - Page ${pageNumber}`;
    }

    return (
      <div>
        <Head
          title={pageName}
          description="Content for founders and entrepreneurs"
          url="https://www.foundercloud.com/blog"
        />
        <PageHeading
          title={pageNumber > 1 ? `The FounderCloud blog, page ${pageNumber}` : "The FounderCloud blog"}
          subHeader="Guides on finding, choosing and working with a co-founder."
        />
        <div className="page__grid">
          <ReactCSSTransitionGroup
            transitionName="overlay"
            transitionAppear={true}
            component={React.Fragment}
            transitionAppearTimeout={500}
            transitionEnter={false}
            transitionLeave={false}
          >
            <div className="blog">
              <BlogArticles variables={variables} />
              <div className="blog__pagination">
                <Query query={BLOG_ARTICLE_CONNECTION_QUERY}>
                  {({ data, loading, error }) => {
                    if (loading) return <p>loading...</p>;
                    const amountOfBlogPosts =
                      data.blogArticlesConnection.aggregate.count;
                    const totalPages = Math.ceil(
                      amountOfBlogPosts / perPageBlogPosts
                    );
                    return (
                      <div className="blog__pag">
                        {pageNumber > 1 && (
                          <Link
                            href={
                              pageNumber !== 2
                                ? `/blog?slug=page-${pageNumber - 1}`
                                : "/blog"
                            }
                            as={
                              pageNumber !== 2
                                ? `/blog/page-${pageNumber - 1}`
                                : "/blog"
                            }
                          >
                            <a className="blog__pag__button">← Prev</a>
                          </Link>
                        )}
                        {amountOfBlogPosts > perPageBlogPosts &&
                          totalPages > pageNumber && (
                            <Link
                              href={`/blog?slug=page-${pageNumber + 1}`}
                              as={`/blog/page-${pageNumber + 1}`}
                            >
                              <a className="blog__pag__button">More →</a>
                            </Link>
                          )}
                        <div className="blog__pag__pag-numbers">
                          page <strong>{pageNumber}</strong> of{" "}
                          <strong>{totalPages}</strong>
                        </div>
                      </div>
                    );
                  }}
                </Query>
              </div>
            </div>
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}

Index.propTypes = {};

export default Index;
